import { render, staticRenderFns } from "./SetPower.vue?vue&type=template&id=b713fe3c&scoped=true"
import script from "./SetPower.vue?vue&type=script&lang=js"
export * from "./SetPower.vue?vue&type=script&lang=js"
import style0 from "./SetPower.vue?vue&type=style&index=0&id=b713fe3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b713fe3c",
  null
  
)

export default component.exports